/* <flux-stappen> — stappenlijst met een fotostapel ernaast.

   Een stap ([data-stap]) wordt actief bij hover, focus of klik. Dan krijgt
   die stap data-actief="true" en schuift de bijbehorende foto ([data-foto])
   naar voren; de twee foto's daarna liggen er scheef achter
   (data-positie: voor | achter-1 | achter-2 | weg). Alle beweging is CSS.

   De server rendert stap 1 als actief, dus zonder JavaScript klopt de
   beginstand ook. */

class FluxStappen extends HTMLElement {
  connectedCallback() {
    this.stappen = [...this.querySelectorAll('[data-stap]')];
    this.fotos = [...this.querySelectorAll('[data-foto]')];
    if (!this.stappen.length) return;
    this.actief = 0;

    this.stappen.forEach((stap, i) => {
      const activeer = () => this.activeer(i);
      stap.addEventListener('mouseenter', activeer);
      stap.addEventListener('focus', activeer);
      stap.addEventListener('click', activeer);
    });
  }

  activeer(index) {
    if (index === this.actief) return;
    this.actief = index;

    this.stappen.forEach((stap, i) => {
      const actief = i === index;
      stap.dataset.actief = actief ? 'true' : 'false';
      if (actief) stap.setAttribute('aria-current', 'step');
      else stap.removeAttribute('aria-current');
    });

    const aantal = this.fotos.length;
    const posities = ['voor', 'achter-1', 'achter-2'];
    this.fotos.forEach((foto, i) => {
      const afstand = (i - index + aantal) % aantal;
      foto.dataset.positie = posities[afstand] || 'weg';
    });
  }
}

if (!customElements.get('flux-stappen')) customElements.define('flux-stappen', FluxStappen);
